import { API } from 'service/api-route';
import AxiosUtils from 'utils/axios-utils';
import type { PickOption } from 'components/add-members-modal';

/** POST /groups/add-user — `users` là chuỗi id cách nhau bởi dấu phẩy ("1,2"). */
export const addMembersToClan = (groupId: number, userIds: number[]) =>
  AxiosUtils.post(API.addUserToGroup, { groupId, users: userIds.join(',') });

export interface ClanMember {
  key: string;
  userId: number | null;
  uid: string | null;
  username: string | null;
  email: string | null;
  fileGroupName: string | null;
  movedFromGroupId: number | null;
  source: 'FILE' | 'MOVED' | 'MANUAL';
  createdAt: string | null;
}

export const removeMemberFromClan = (groupId: number, key: string) =>
  AxiosUtils._delete(`${API.domesticMembers(groupId)}/${encodeURIComponent(key)}`, {});

export const moveMemberToClan = (groupId: number, key: string, targetGroupId: number) =>
  AxiosUtils.post(`${API.domesticMembers(groupId)}/${encodeURIComponent(key)}/move`, { targetGroupId });

/** GET /groups/search?query= — tìm nhóm theo tên. */
export const searchClanOptions = async (search: string): Promise<PickOption[]> => {
  const res: any = await AxiosUtils.get(API.searchGroup, { query: search });
  const list: any[] = Array.isArray(res?.data) ? res.data : [];
  return list.map((item) => ({ value: item.id, label: item.title }));
};
